var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiButtonGroup from '@material-ui/core/ButtonGroup';
var MuiButtonGroupComponent = MuiButtonGroup;
/**
 * Kareo wrapped component of the Material-UI ButtonGroup. The prop API has been limited to props defined in ButtonGroupProps.
 *
 * The ButtonGroup component can be used to group related buttons.
 *
 * Material-UI ButtonGroup: [Docs](https://v4.mui.com/components/button-group/), [API](https://v4.mui.com/api/button-group/)
 *
 * @storybook: [ButtonGroup](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-button-buttongroup--button-group-main)
 */
var ButtonGroup = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    return React.createElement(MuiButtonGroupComponent, __assign({}, props, { ref: ref, variant: "contained" }));
});
ButtonGroup.defaultProps = { color: 'vitality' };
ButtonGroup.displayName = 'KareoButtonGroup';
export default ButtonGroup;
